import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["Badge"] */ "/vercel/path0/packages/ui/src/badge.tsx");
